export const BUSINESS_HOURS_LOAD_REQUEST =
  'reports/businessHours/BUSINESS_HOURS_LOAD_REQUEST'
export const BUSINESS_HOURS_LOAD_RESPONSE =
  'reports/businessHours/BUSINESS_HOURS_LOAD_RESPONSE'
export const BUSINESS_HOURS_LOAD_ERROR =
  'reports/businessHours/BUSINESS_HOURS_LOAD_ERROR'
export const BUSINESS_HOURS_SAVE_REQUEST =
  'reports/businessHours/BUSINESS_HOURS_SAVE_REQUEST'
export const BUSINESS_HOURS_SAVE_RESPONSE =
  'reports/businessHours/BUSINESS_HOURS_SAVE_RESPONSE'
export const BUSINESS_HOURS_SAVE_ERROR =
  'reports/businessHours/BUSINESS_HOURS_SAVE_ERROR'
export const BUSINESS_HOURS_DAY_ENABLED_CHANGE =
  'reports/businessHours/BUSINESS_HOURS_DAY_ENABLED_CHANGE'
export const BUSINESS_HOURS_TIME_CHANGE =
  'reports/businessHours/BUSINESS_HOURS_TIME_CHANGE'
export const BUSINESS_HOURS_TIMEZONE_CHANGE =
  'reports/businessHours/BUSINESS_HOURS_TIMEZONE_CHANGE'
